import React from "react";
import { Clock, Phone, Mail, Facebook, Instagram, Youtube, Twitter } from "lucide-react";
import { SCHOOL } from "../data/siteData";
import "./TopBar.css";

const TopBar = () => {
  return (
    <div className="topbar">
      <div className="container topbar__inner">
        <div className="topbar__left">
          <span className="topbar__item">
            <Clock size={13} className="topbar__icon" /> {SCHOOL.timing}
          </span>
          <span className="topbar__item">
            <Phone size={13} className="topbar__icon" />
            <a href={`tel:${SCHOOL.phone}`}>{SCHOOL.phone}</a>
          </span>
          <span className="topbar__item">
            <Mail size={13} className="topbar__icon" />
            <a href={`mailto:${SCHOOL.email}`}>{SCHOOL.email}</a>
          </span>
        </div>
        <div className="topbar__right">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook size={15} /></a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram size={15} /></a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><Youtube size={15} /></a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><Twitter size={15} /></a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
